import { Action, createReducer, on } from '@ngrx/store';
import * as StatisticsActions from '../actions/statistics.actions';
import { OrderStatistic } from '../../helpers/statistics.helper';
import { ProductStatistic } from '../../commons/models/product';
import { ZoneStatistic } from '../../commons/models/zone';

// Definizione dell'interfaccia dello stato
export interface StatisticsState {
  orders: OrderStatistic[];      // Dati sugli ordini
  products: ProductStatistic[];  // Dati sui prodotti
  zones: ZoneStatistic[];       // Dati sulle zone
  loading: boolean;              // Stato di caricamento
  error: any;                    // Errore nel caso in cui la chiamata fallisca
  startDate: Date;               // Data di inizio per i filtri
  endDate: Date;                 // Data di fine per i filtri
  tenant_id?: number | null;      // Filtro tenant
}

const initialState: StatisticsState = {
  orders: [],
  products: [],
  zones: [],
  loading: false,
  error: null,
  startDate: new Date(),
  endDate: new Date(),
  tenant_id: null
};

const statisticsReducer = createReducer(
  initialState,

  // Caricamento delle statistiche degli ordini
  on(StatisticsActions.loadOrderStatisticsCompleted, (state, {orders}) => {
    return {...state, orders: orders}
  }),
 
  // on(StatisticsActions.loadOrderStatisticsFailed, (state, { error }) => ({
  //   ...state,
  //   loading: false,
  //   error
  // })),

  // Caricamento delle statistiche dei prodotti
  on(StatisticsActions.loadProductStatisticsCompleted, (state, {products}) => {
    //console.log("Aggiornamento stato con i prodotti nel reducer:", products);
    return {...state, products: products}
  }),
  
  // on(StatisticsActions.loadProductStatisticsFailed, (state, { error }) => ({
  //   ...state,
  //   loading: false,
  //   error
  // })),

  // Caricamento delle statistiche delle zone
  on(StatisticsActions.loadZoneStatisticsCompleted, (state, {zones}) => {
    //console.log("Reducer aggiornato con:", zones);
    return {...state, zones: zones}
  }),
 
  // on(StatisticsActions.loadZoneStatisticsFailed, (state, { error }) => ({
  //   ...state,
  //   loading: false,
  //   error
  // })),

  // Cambio delle date
  on(StatisticsActions.changeStatisticsDateRange, (state, { startDate, endDate }) => ({
    ...state,
    startDate,
    endDate
  })),

  // Cambiamento del filtro tenant
  on(StatisticsActions.changeTenantFilter, (state, { tenant_id }) => ({
    ...state,
    tenant_id
  }))
);

export function reducer(state: StatisticsState | undefined, action: Action) {
  return statisticsReducer(state, action);
}
